// Tiny event bus for the "What's New" modal so any component can ask it to
// open without context plumbing. The modal's owning component listens for
// `whatsnew:open` once at mount and toggles its local state in response.

const EVENT_NAME = "whatsnew:open";

export function openWhatsNew() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(EVENT_NAME));
}

export function onWhatsNewOpen(handler) {
  if (typeof window === "undefined") return () => {};
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
